import { render, staticRenderFns } from "./videolist.vue?vue&type=template&id=65500d92"
import script from "./videolist.vue?vue&type=script&lang=js"
export * from "./videolist.vue?vue&type=script&lang=js"
import style0 from "./videolist.vue?vue&type=style&index=0&id=65500d92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports